import createModule from "../createModule"
import view from "./view"
import { get } from "lodash"
import { getHelpArticles } from "./selectors"

export default createModule({
  view,
  externalProps: (state, props) => ({
    account: state.global.selected.account,
    modelId: props.modelId,
  }),
  required: ["account"],
  data: [{
    resource: "modelDataset",
    as: null,
    url: ({ account, modelId }) => {
      if (!modelId) { return null }
      return ({
        id: `modelDataset-${modelId}`,
        url: `/api/${account}/datacloud/datasets/${modelId}`,
      })
    },
  }],
  mapStateToProps: (state, props) => ({
    ...get(state, "global.data.modelDataset.data", {}),
    helpArticles: getHelpArticles(state, props),
  }),
})
